import React from 'react';
import heroThumbOne from '../../assets/images/heroDevice.png';
import shapeTwo from '../../assets/images/shape/shape-2.png';
import shapeThree from '../../assets/images/shape/shape-3.png';
import shapeFour from '../../assets/images/shape/shape-4.png';
import { APP_URLS } from '../../constants/urls';
function HeroHomeOne({ className }) {
  
    return (
        <>
            <section className={`appie-hero-area ${className || ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="appie-hero-content">
                                <span>Supermedic Hire</span>
                                <h1 className="appie-title">Your One-Stop Platform for Healthcare Hiring.</h1>
                                <p>Whether it’s locum, contract, or permanent roles, Supermedic delivers top talent quickly and seamlessly.  Qualified professionals, instant access, and stress-free recruitment—built for clinics, hospitals, healthcare facilities  and recruitment agencies.</p>
                                <ul>
                                    <li>
                                        <a href={APP_URLS.facilities.apple} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-apple" /> Download for iOS
                                        </a>
                                    </li>
                                    <li>
                                        <a className="item-2" href={APP_URLS.facilities.google} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-google-play" /> Download for Android
                                        </a>
                                    </li>
                                    <li>
                                        <a href={APP_URLS.facilities.huawei} target="_blank" rel="noopener noreferrer">
                                            <i className="fas fa-mobile-alt" /> Download for Huawei
                                        </a>
                                    </li>
                                    <li>
                                        <a className="item-2" href={APP_URLS.facilities.web} target="_blank" rel="noopener noreferrer">
                                            <i className="fas fa-globe" /> Open Web App
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-hero-thumb">
                                <div
                                    className="thumb wow animated fadeInUp"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="200ms"
                                >
                                    <img src={heroThumbOne} alt="" height={650} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-shape-1">
                    <img src={shapeTwo} alt="" />
                </div>
                <div className="hero-shape-2">
                    <img src={shapeThree} alt="" />
                </div>
                <div className="hero-shape-3">
                    <img src={shapeFour} alt="" />
                </div>
            </section>
        </>
    );
}

export default HeroHomeOne;
